import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#basic-usage" }),
  /*#__PURE__*/_createTextVNode(" Basic usage ")
], -1)
const _hoisted_3 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_el_select, {
        modelValue: _ctx.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value = $event)),
        placeholder: "Select"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code1), 1)
        ]),
        _: 1
      })
    ])
  ]))
}